export const data = [
    {
        id: "0",
        question: "What is FIRST's goal?",
        answer: "To inspire young people to be science and technology leaders and innovators",
        variants: [`To inspire young people to be science and technology leaders and innovators`, `To dominate the youth robotics world`, `Encourage rivalries between local teams`, `Conquer the world`]
    },
    {
        id: "1",
        question: "What are the FIRST competition categories other than FRC?",
        answer: "FTC, FLL",
        variants: [`SCDC, ICDC`, `FOO, FRP`, `FTC, FLL`, `DCMP, Worlds`]
    },
    {
        id: "2",
        question: "What does FRC stand for?",
        answer: "FIRST Robotics Competition",
        variants: [`FIRST Rocketry Challenge`, `FIRST Robotics Competition`, `FIRST Rising Champions`, `FIRST Robotic Challengers`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },